import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreIcon from '@material-ui/icons/MoreVert';
import configBase from '../../../../configBase';



class Topbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      linkElemento: null,
    };

  }

  pegaElementoMenu(e) {
    let state = this.state;
    state.linkElemento = e.target;
    this.setState(state);
  }

  pegaEscolhaMenu(e) {
    let state = this.state;
    state.linkElemento = null;
    this.setState(state);
    
    if (e.target.id) {
      if (e.target.id === 'i_sair')
        this.props.history.push(`${process.env.PUBLIC_URL}/sair`);
      else// i_senha
        this.props.history.push(`${process.env.PUBLIC_URL}/alterarsenha`);
    }
  }

  render() {
    const {onSidebarOpen, onSidebarClose, openSidebar} = this.props;

    let functionOnOffSidebar = onSidebarOpen;

    if (openSidebar === true)
      functionOnOffSidebar = onSidebarClose;

    return (
      <div id="appBar">
        <AppBar position="static" style={{backgroundColor:  configBase.corPrincipal}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={functionOnOffSidebar}
            >
              <MenuIcon />
            </IconButton>

            <div style={{flexGrow: 1, alignSelf: 'flex-end'}} />

            <IconButton aria-label="display more actions" edge="end" color="inherit" onClick={this.pegaElementoMenu.bind(this)}>
              <MoreIcon />
            </IconButton>

            <Menu
              id="simple-menu"
              anchorEl={this.state.linkElemento}
              keepMounted
              open={Boolean(this.state.linkElemento)}
              onClose={this.pegaEscolhaMenu.bind(this)}
            >
              <MenuItem id="i_senha" onClick={this.pegaEscolhaMenu.bind(this)}>Alterar Senha</MenuItem>
              <MenuItem id="i_sair" onClick={this.pegaEscolhaMenu.bind(this)}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
  onSidebarClose: PropTypes.func,
  openSidebar: PropTypes.bool.isRequired,
  history: PropTypes.object,
};

export default Topbar;